import { motion } from "framer-motion";
import Reveal from "@/components/landing/Reveal";
import { renderTitle, toFullUrl } from "@/components/landing/utils";

const BOTTLES = ["/perfumes/dama-blanco.png", "/perfumes/caballero-60.png"];

export default function FoundersSection({ block }) {
  const people = block?.people || [];
  return (
    <section id="equipo" className="section-elev py-20 md:py-32 relative overflow-hidden" data-testid="founders-section">
      {BOTTLES.map((b, i) => (
        <motion.img key={b} src={b} alt="" aria-hidden loading="lazy" decoding="async"
          className={`hidden lg:block absolute w-24 xl:w-32 opacity-70 pointer-events-none drop-shadow-2xl ${i === 0 ? "left-6 top-24" : "right-8 bottom-16"}`}
          animate={{ y: [0, -14, 0], rotate: i === 0 ? [-4, 2, -4] : [3, -3, 3] }} transition={{ duration: 7 + i, repeat: Infinity, ease: "easeInOut" }} />
      ))}
      <div className="max-w-[1300px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="max-w-3xl text-center mx-auto">
          <Reveal><span className="eyebrow">La gente detrás</span></Reveal>
          <Reveal delay={120}>
            <h2 className="mt-4 font-display text-4xl md:text-5xl text-[#0A0A0A]">{renderTitle(block?.title || "La expansión sigue siendo <em>liderada por quienes construyeron Rubí</em>")}</h2>
          </Reveal>
          {block?.body && <Reveal delay={220}><p className="mt-6 text-[#3F3F46] text-base md:text-lg leading-relaxed">{block.body}</p></Reveal>}
        </div>
        {people.length > 0 && (
          <div className="mt-12 md:mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-testid="founders-people">
            {people.map((p, i) => (
              <Reveal key={i} delay={i * 120}>
                <div className="group rounded-3xl overflow-hidden bg-white border border-black/6 h-full">
                  <div className="aspect-[4/5] sm:aspect-[4/4.6] relative overflow-hidden bg-[#18181B]">
                    {toFullUrl(p.image_url) && <img src={toFullUrl(p.image_url)} alt={p.name} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-700" />}
                    <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-[#0A0A0A]/85 to-transparent" />
                    <div className="absolute bottom-4 left-5 right-5">
                      <div className="text-white font-display text-xl md:text-2xl">{p.name}</div>
                      <div className="text-[10px] uppercase tracking-[0.2em] font-mono text-[#FFBF57] mt-1">{p.role}</div>
                    </div>
                  </div>
                  <p className="p-5 md:p-6 text-sm text-[#3F3F46] leading-relaxed">{p.bio}</p>
                </div>
              </Reveal>
            ))}
          </div>
        )}
        {block?.quote && (
          <Reveal delay={320}>
            <div className="mt-14 max-w-3xl mx-auto text-center">
              <blockquote className="font-display text-2xl md:text-3xl text-[#0A0A0A] leading-snug">&ldquo;{block.quote}&rdquo;</blockquote>
              <div className="mt-4 text-[11px] uppercase tracking-widest text-[#FFBF57] font-mono">{block.quote_author} {block.quote_role && <span className="text-[#52525B]"> · {block.quote_role}</span>}</div>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
